

document.addEventListener('DOMContentLoaded', function() {

setTimeout(() => {
    // Función para cambiar la cantidad de productos, específica a cada tarjeta
    document.querySelectorAll('.mox-subs-container').forEach(container => {
        const quantityDisplay = container.querySelector('.mox-subs-quantity-display');
        let quantity = parseInt(quantityDisplay.textContent);
        container.querySelector('.mox-subs-increase').addEventListener('click', () => {
            quantity++;
            quantityDisplay.textContent = quantity;
        });

        container.querySelector('.mox-subs-decrease').addEventListener('click', () => {
            if (quantity > 1) {
                quantity--;
                quantityDisplay.textContent = quantity;
            }
        });
    });
  
}, "1000");

    const checkboxes = document.querySelectorAll('.pdp-selector-checkbox');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(cb => {
                    if (cb.checked == true) {
                        cb.checked = false;
                    }
                });
this.checked = true
            }
        });
    });


  document.querySelectorAll('.t4s-form__product .t4s-swatch__list .t4s-swatch__item').forEach(item => {
    item.addEventListener('click', function () {
      setTimeout(() => {

        let subs_price = document.querySelector('#current_variant_price');
                            
        let current_variant_price = 
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price ins') ||
          document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product-price');


            if (current_variant_price) {
                let priceText = current_variant_price.textContent;
                let cleanPrice = priceText.replace(/[$.,\s]/g, '');
                subs_price.value = cleanPrice;
            }
    
        // Leer el valor de data-value
        const dataValue = this.getAttribute('data-value-position');

        const match = dataValue.match(/\d+/);
        const number = match ? match[0] : null;

        if (number) {

            document.querySelectorAll('.tab-container .discount-label').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTab = document.querySelector(`.tab-container .dis-standard-${number}`);
            if (targetTab) {
                targetTab.style.display = '';
            }

            document.querySelectorAll('.tab-container .discount-label-subs').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTabSubs = document.querySelector(`.tab-container .dis-standard-subs-${number}`);
            if (targetTabSubs) {
                targetTabSubs.style.display = '';
            }

        }
        calculatePrice()
        
      }, 50);        
    });
   });


  
});

const deliveryOptions = document.querySelector("#delivery-options");

function showTabContent(event, tabId, discountApplied, attributeName) {
  // Ocultar todo el contenido de las pestañas
  var contents = document.querySelectorAll('.tab-content');
  contents.forEach(function(content) {
    content.classList.remove('active');
  });

  // Quitar la clase 'active' de todas las pestañas
  var tabs = document.querySelectorAll('.tab');
  tabs.forEach(function(tab) {
    tab.classList.remove('active');
    tab.classList.add('inactive');
  });

  // Mostrar el contenido seleccionado y marcar la pestaña activa
  document.getElementById(tabId).classList.add('active');
  event.currentTarget.classList.add('active');
  event.currentTarget.classList.remove('inactive');

  // Lógica adicional para tab1
  if (tabId === 'tab1') {
    var lineItemField = document.querySelector('.t4s-main-area .line-item-property__field');
    if (lineItemField) {
      lineItemField.innerHTML = `
          <input id="subscription-price" type="text" name="properties[Compra Unica]">
      `; 
    }
  }

  // Lógica adicional para tab2
  if (tabId === 'tab2') {
    let lineItemField = document.querySelector('.t4s-main-area .line-item-property__field');
    if (lineItemField) {
      // Declarar la variable frequency
      let deliveryOptionsAvai = document.querySelector('#delivery-options');
      let frequency = deliveryOptionsAvai ? deliveryOptionsAvai.value : ''; // Asignar valor del select o vacío si no existe

      var original_price = $("#current_variant_price").val();
      var subscription_discount = $("#subscription_discount").val();
      var suscription_price = original_price - (original_price * subscription_discount / 100);
       console.log("mirame", suscription_price)
      
      lineItemField.innerHTML = `
        <label for="subscription-price">subscription-price</label>
        <input id="subscription-price" type="text" name="properties[_subscription_price]" value="${suscription_price}">
        <input id="subscription-freq" type="text" name="properties[_subscription_freq]" value="${frequency}">
        <input type="text" name="properties[_subscription_discount_applied]" value="${discountApplied}">       
        <input id="${attributeName}" type="text" name="properties[${attributeName}]" value="${discountApplied}">
      `;
    }

  }

    setTimeout(() => {
      let subscriptionFreq = document.querySelector("#subscription-freq");
  
      if (deliveryOptions && subscriptionFreq) {
          deliveryOptions.addEventListener("change", function () {
  
              subscriptionFreq.value = this.value; // Obtiene el valor seleccionado del <select>
          });
      }

    }, "500");

  
}





